export default "__VITE_ASSET__DiDRYlmA__"